import { ModelSagres } from "../model-sagres"
import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";

export class EnviosSM extends ModelSagres {
    Id: number
    Ano: number
    Mes: number
    ugPcm: number
    idSistema: number
    exercicio: number
    mesInicial: number
    mesFinal: number
    UnidadeGestora?: UnidadeGestoraResumida | string
    Nome: string
    Descricao: string

    toFormData(): FormData {
        const data = new FormData()
        for (const key in this) {
            if(key == 'idSistema'){
                data.append('idSistema', String(this[key]))
            }
            if(key == 'UnidadeGestora' && this.UnidadeGestora){
                data.append('ugPcm', String((this.UnidadeGestora as UnidadeGestoraResumida).IdPCM))
            }
            if(key == 'exercicio'){
                data.append('exercicio', String(this[key]))
            }
            if(key == 'mesInicial'){
                data.append('mesInicial', String(this[key]))
            }
            if(key == 'mesFinal'){
                data.append('mesFinal', String(this[key]))
            }
        }
        return data
    }
}